import React from "react";
import location from "../../assest/location.svg";
import me from "../../assest/me.JPG";
import "./aboutme.css";
import { WorkOutlineRounded } from "@mui/icons-material";
import { Button } from "@mui/material";
import { Helmet } from "react-helmet-async";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { loadPortfolio } from "../../redux/action";
const AboutMe = () => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(loadPortfolio());
  }, [dispatch]);
  const { portfolioData, loading } = useSelector((state) => state.portfolio);

  return (
    <>
      <Helmet>
        <title>Home Page</title>
        <meta
          name="keywords"
          content=" Debabrata Basak, Software Engineer at Mitt Arv Technologies Private Limited."
        />
        <link rel="canonical" href="/" />
      </Helmet>
      <div className="main_about__section">
        <div className="left_about__section">
          <p className="about_heading__para">Hi, I’m Debabrata Basak 👋</p>
          <p className="about_description_para">
            {
              loading? "Loading...." : portfolioData?.[0]["about"]
            }
          </p>
          <div className="location">
            <img src={location} alt="location" />
            <p>Jalpaiguri, West bengal</p>
          </div>
          <div className="available">
            <div className="blue_dot"></div>
            <p>Available for new projects</p>
          </div>
          <div className="available desktop_view">
            <WorkOutlineRounded />
            <p>
              Currently Working at Mitt Arv as Software Development Engineer
            </p>
          </div>
          <a
            href="https://play.google.com/store/apps/details?id=com.superapp.mittarv"
            target="_blank"
            rel="noreferrer"
          >
            <Button id="download_mittarv_button" variant="outlined">
              <p className="download_btn__text">Download Mitt Arv</p>
            </Button>
          </a>
        </div>
        <div className="right_about__section">
          <img src={me} alt="" className="me_photo" />
        </div>
      </div>
    </>
  );
};

export default AboutMe;
